import axios from 'axios'
import { remove, convert, sort } from './utils'
import { merge, cloneDeep } from 'lodash'
import i18n from '@/lib/language'
class AxiosBase {
  constructor ({
    url,
    method,
    params = {},
    config = {},
    axiosConfig = {},
    requests = [],
    responses = [],
    netSuccesses = [],
    netFails = [],
    netCompletes = []
  }) {
    this.axios = axios.create(axiosConfig)
    this.__url = url
    this.__method = method || axiosConfig.method || 'get'
    this.__params = cloneDeep(params)
    this.__config = cloneDeep(config)
    this.__axiosConfig = cloneDeep(axiosConfig)
    this.__requests = cloneDeep(requests)
    this.__responses = cloneDeep(responses)
    this.__netSuccesses = cloneDeep(netSuccesses)
    this.__netFails = cloneDeep(netFails)
    this.__netCompletes = cloneDeep(netCompletes)
  }
  _queue (to, data, name) {
    const { id, index } = convert(name)
    to.push({ id, index, val: data })
    return this
  }
  url (url) {
    this.__url = url
    return this
  }
  method (method) {
    this.__method = method
    return this
  }
  params (params = {}) {
    merge(this.__params, params)
    return this
  }
  getParams () {
    return this.__params
  }
  config (cfg = {}) {
    merge(this.__config, cfg)
    return this
  }
  getConfig () {
    return this.__config
  }
  axiosConfig (cfg = {}) {
    merge(this.__axiosConfig, cfg)
    return this
  }
  getAxiosConfig () {
    return this.__axiosConfig
  }
  onRequest (mixed, name) {
    return this._queue(this.__requests, mixed, name)
  }
  offRequest (name) {
    this.__requests = remove(this.__requests, name)
    return this
  }
  onResponse (mixed, name) {
    return this._queue(this.__responses, mixed, name)
  }
  offResponse (name) {
    this.__responses = remove(this.__responses, name)
    return this
  }
  onNetSuccess (func, name) {
    return this._queue(this.__netSuccesses, func, name)
  }
  offNetSuccess (name) {
    this.__netSuccesses = remove(this.__netSuccesses, name)
    return this
  }
  onNetFail (func, name) {
    return this._queue(this.__netFails, func, name)
  }
  offNetFail (name) {
    this.__netFails = remove(this.__netFails, name)
    return this
  }
  onNetComplete (func, name) {
    return this._queue(this.__netCompletes, func, name)
  }
  offNetComplete (name) {
    this.__netCompletes = remove(this.__netCompletes, name)
    return this
  }
  dequeueInterceptors () {
    const intercept = (queues, type) => {
      queues.forEach(item => {
        let { val } = item
        if (typeof val === 'function') {
          val = [val]
        }
        const [func1 = params => params, func2 = () => {}] = val
        this.axios.interceptors[type].use(func1, func2)
      })
    }

    intercept(sort(this.__requests), 'request')
    intercept(sort(this.__responses), 'response')
    return this
  }
  getRestfulPromise () {
    const params = this.__params
    const url = this.__url
    const axiosConfig = this.__axiosConfig
    const method = this.__method
    let promise
    delete axiosConfig.method
    if (method === 'get') {
      axiosConfig.params = params
      promise = this.axios.get(url, axiosConfig)
    } else if (method === 'post' || method === 'put' || method === 'patch') {
      promise = this.axios[method](url, params, axiosConfig)
    } else if (
      method === 'delete' ||
      method === 'head' ||
      method === 'options'
    ) {
      // TODO: 不熟悉当前这三个的处理是否需要与get一致？
      promise = this.axios[method](url, axiosConfig)
    } else {
      // 按POST处理
      promise = this.axios.post(url, params, axiosConfig)
    }
    return promise
  }

  fetch () {
    const deal = async (queues, data) => {
      const { length } = queues
      for (let i = 0; i < length; i++) {
        const item = queues[i]
        const { val } = item
        await val.call(this, data)
      }
    }
    const promise = this.dequeueInterceptors().getRestfulPromise()
    return promise
      .then(async raw => {
        if (raw) {
          try {
            await deal(sort(this.__netSuccesses), raw)
          } catch (err) {
            console.log(err)
            window.$sentry.log(err)
          }
          return raw
        } else {
          throw new Error(i18n.t('message["1250"]') + '!')
        }
      })
      .catch(async err => {
        await deal(sort(this.__netFails), err)
        window.$sentry.log(err)
      })
      .finally(async () => {
        await deal(sort(this.__netCompletes))
      })
  }
}
export default AxiosBase
